<template>
  	<li class="card">
  		<div class="card-actions" v-if="user">
			<button type="button" v-on:click.stop="remove">
				delete
			</button>
			<button class="card-edit" type="button" @click="updateModal">
				edit
			</button>
			<button class="card-add-stack" type="button" @click="stackModal">
				edit stacks
			</button>
		</div>
		<span class="card-type">{{card.type}}</span>
		<div class="card-preview-stack" v-if="card.type == 'stack'">
			<a :href="card.url">
				<h3>{{card.title}}</h3>
				<small>{{card.length}} cards by {{card.username}}</small>
			</a>

		</div>
		<div v-else>
			<h5 class="card-source">{{card.source}}</h5>
	    	<h3 class="card-title"><a :href="card.url" target="_blank">{{card.title}}</a></h3>
	    	<div class="card-preview">
	    		<a :href="card.url" target="_blank">
		    	<img :src="card.image" class="card-image" v-if="card.show === 'image'" />
		    	<blockquote v-if="card.show === 'text'">{{card.snippet}}</blockquote>
		    	</a>
	    	</div>
    	</div>
    	<p class="card-curator-note" v-if="card.description"><strong>{{card.username}}:</strong> {{card.description}}</p>

   
		<a class="card-stacks" href="javascript:void(0)" v-on:click.stop="stackModal">
			stacks 
			<span v-if="card.stackCount > 0">({{card.stackCount}})</span>
			<span v-else>(0)</span>
		</a>

    	<span class="card-count" v-if="stack">{{index + 1}} / {{stack.cardCount}} cards</span>
  	</li>
</template>

<script>
	import cardRepository from '../../data/CardRepository'
	import stackFunctions from '../../data/stackFunctions'
	import EventBus from '../EventBus'
  	export default {
    	props: ['card', 'stack', 'user', 'index'],
	    // here you define the attributes/props of the component, will be available via this.note
	    // when using component you can use the prop externally via '<note :note"{title: 'hi', content: 'lorem'}" ></note>'
	    methods: {
	    	remove() {
			    cardRepository.remove(this.card, (err) => {
	  				if (err) throw err	
	  			})
	    	},
	    	updateModal() {
	    	    EventBus.$emit('card.selected', this.card)
	    	},
	    	stackModal() {
	    		EventBus.$emit('card.stack', this.card)
	    	}
	    },
	    mounted() {
	    }

  	}
</script>


// WEBPACK FOOTER //
// Card.vue?82364e3e